import { deleteUserAPI } from "../infrastructure/user.api";

export async function deleteUser(id: number): Promise<void> {
  return await deleteUserAPI(id);
}
